/**
 * @typedef {import('../types.d.ts').BaseInterface} BaseInterface
 * @typedef {{
 *   components?: Array<BaseInterface>,
 *   lazyComponents?: Array<[string, () => Promise<BaseInterface>]>,
 * }} CreateAppOptions
 */

/**
 * Create an app.
 *
 * @param   {CreateAppOptions} options
 * @returns {Promise<void>}
 */
export async function createApp(options) {
  if (options.components) {
    for (const Class of options.components) {
      Class.$register();
    }
  }

  if (options.lazyComponents) {
    const resolvers = options.lazyComponents
      .map(([name, resolver]) => {
        if (document.querySelector(name)) {
          return resolver().then((Class) => {
            Class.$register();
          });
        }
      })
      .filter(Boolean);

    await Promise.all(resolvers);
  }
}
